import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=d81e89be"
import script from "./EmployeeCard.vue?vue&type=script&lang=ts"
export * from "./EmployeeCard.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeCard.vue?vue&type=style&index=0&id=d81e89be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports